"use strict";

define('app/document/decision/document.decision.controller',['rs/abstract.content.controller', 'e3-table', 'rs/models/document', 'rs/models/meeting.document', 'rs/models/document.letter', 'rs/models/letter', 'rs/models/meeting', 'rs/models/setting', 'rs/models/pdf', 'rs/models/assignment.builder', 'rs/helper', 'evisions/validation', 'app/document/decision/document.decision.view', 'rs/models/decision.category', 'moment'], function (AbstractContentController, E3Table, Document, MeetingDocument, DocumentLetter, Letter, Meeting, Setting, PDFGenerator, AssignmentBuilder, helper, validation, DocumentDecisionView, DecisionCategory, moment) {
  var DocumentDecisionController = AbstractContentController.extend({
    contentName: 'document-decision-content abstract-content meeting-notes fixed-header off-white',
    properties: ['availableCategories', 'changeOccured', 'decision', 'decisionTypes', 'editable', 'editMode', 'letters', 'letterTable', 'meetingDocument', 'meetingId', 'reviewType', 'selectedDecisionType', 'categoryQuery', 'studyDefaultExpirationInterval'],
    expirationDateIncrementProperty: 'IRB.SUBMISSION_DEFAULT_EXPIRE_DATE',
    letterColumns: [{
      name: 'subject',
      displayName: 'Subject',
      width: '30%'
    }, {
      name: 'recipients',
      displayName: 'Recipients',
      width: '55%'
    }, {
      name: 'dateSent',
      type: 'date',
      displayName: 'Date Sent',
      width: '15%'
    }],
    previousMeetingsColumns: [{
      namespace: 'meeting.startDate',
      type: 'date',
      displayName: 'Date',
      width: '20%'
    }, {
      name: 'notes',
      displayName: 'Notes',
      width: '80%',
      type: 'html'
    }],
    validation: ['decisionTypeId', 'resultDate', 'expirationDate', 'voteFor', 'voteAgainst', 'voteAbstain', 'recused', 'findings', 'internalNotes', 'researchNotes', 'categories'],
    validators: {
      decisionTypeId: [],
      resultDate: [validation.date(), 'validateResultDate'],
      expirationDate: [validation.date(), 'validateExpirationDate'],
      voteFor: [validation.number()],
      voteAgainst: [validation.number()],
      voteAbstain: [validation.number()],
      recused: [],
      findings: [],
      internalNotes: [],
      researchNotes: []
    },
    editable: true,
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.setEditMode(false);
      this.setChangeOccured(false);
      this.sync('editMode');
      this.startListeners();
    },
    startListeners: function startListeners() {
      var view = this.getView();
      this.listenTo(this, 'change:selectedDecisionType', this.selectedDecisionTypeDidChange);
      this.listenTo(this, 'change:categoryQuery', this.refreshAvailableCategories);
      this.listenTo(view, 'change:decisionType', function () {
        var decisionTypeId = view.getDecisionTypeId(),
          decisionType = _.findWhere(this.getDecisionTypes(), {
            id: Number(decisionTypeId)
          });
        this.setSelectedDecisionType(decisionType);
      });
      this.listenTo(view, 'change:resultDate', function () {
        this.refreshExpirationDateOnView();
      });
    },
    setupView: function setupView() {
      this.setView(new DocumentDecisionView());
    },
    viewIsAvailable: function viewIsAvailable() {
      var view = this.getView(),
        that = this,
        table = null,
        letters = this.getLetters();
      if (!_.isEmpty(letters)) {
        table = new E3Table.Controller({
          delegate: this,
          columns: this.letterColumns,
          theme: 'rs'
        });
        table.setup(view.getLetterTableElement());
        this.setLetterTable(table);
        table.start();
      }
      this._super();
      this.listenTo(this, 'change:selectedDecisionType', function () {
        view.setExpirationDateEnabled(this.shouldUseExpirationDate());
        this.refreshExpirationDateOnView();
      });
      this.listenTo(this, 'change:availableCategories', function () {
        this.refreshDecisionCategories(_.pluck(this.getDecision().getCategories(), 'id'));
        view.refreshCategories();
      });
      this.listenTo(view, 'change:category', function () {
        this.refreshDecisionCategories(view.getSelectedCategoryIds());
      });
    },
    refreshDecisionCategories: function refreshDecisionCategories(selectedIds) {
      var availableCategories = this.getAvailableCategories(),
        selectedCategories = [];
      for (var i = 0, len = availableCategories.length, category; i < len; i++) {
        category = availableCategories[i];
        if (_.contains(selectedIds, category.getId())) {
          selectedCategories.push(category);
        }
      }
      this.getDecision().setCategories(selectedCategories);
    },
    refreshExpirationDateOnView: function refreshExpirationDateOnView() {
      var useExpirationDate = this.shouldUseExpirationDate(),
        view = this.getView(),
        resultDate = view.getResultDate(),
        expirationDate = view.getExpirationDate(),
        addDays = this.getStudyDefaultExpirationInterval();
      if (useExpirationDate && !expirationDate && _.isDate(resultDate)) {
        if (this.shouldAutoPopulate()) {
          view.setExpirationDate(moment(resultDate).add(addDays, 'days').toDate());
        }
      }
    },
    shouldAutoPopulate: function shouldAutoPopulate() {
      return this.getReviewType() != 'EXEMPT';
    },
    getData: function getData() {
      return this.getLetters();
    },
    tableItemWasSelected: function tableItemWasSelected(item, table) {
      if (table === this.getLetterTable()) {
        this.letterSelectionDidChange();
      }
    },
    letterSelectionDidChange: function letterSelectionDidChange() {
      var table = this.getLetterTable(),
        item = table.getSelectedItem(),
        docLetter = null,
        doc = this.getDecision().getDocument();
      var popup = PDFGenerator.generatePopup();
      if (item) {
        docLetter = item.item;
        docLetter.requestCurrentContent(doc.getId()).then(function (content) {
          PDFGenerator.requestCreatePDF(content, popup);
          table.clearSelectedItems();
        }).lastly(this.showLoading());
      }
    },
    start: function start(documentId, meetingId) {
      var view = this.getView();
      this.setMeetingId(meetingId || null);
      return Document.requestOpenDecisions(documentId).bind(this).then(function (decisions) {
        if (_.isEmpty(decisions)) {
          return Promise.reject("No available decisions.");
        }
        var myDecision = decisions[0].getDecisionByResponsiblePersonId(this.getAppController().getUser().getPersonId());
        if (!myDecision) {
          return Promise.reject("No available decisions.");
        }
        if (myDecision.finalizedDate == null) {
          this.setEditMode(true);
        }
        this.setDecision(myDecision);
        return Promise.all([myDecision.requestTypes(), Setting.requestOne('studyDefaultExpirationInterval')]);
      }).spread(function (types, studyDefaultExpirationInterval) {
        var myDecision = this.getDecision(),
          myDecisionType = myDecision.getDecisionType();
        this.setDecisionTypes(types);
        this.render();
        this.setReviewType(myDecision.getType());
        this.setSelectedDecisionType(myDecisionType);
        if (!myDecisionType) {
          this.refreshCategoryQuery(myDecisionType);
        }
        this.setStudyDefaultExpirationInterval(Number(studyDefaultExpirationInterval) || 365);
      });
    },
    isCategoryRequired: function isCategoryRequired() {
      var decisionType = this.getSelectedDecisionType(),
        decisionTypeDescription = decisionType ? decisionType.description : null;
      switch (this.getReviewType()) {
        case 'EXPEDITED':
        case 'EXEMPT':
          if (decisionTypeDescription == 'Approved') {
            return true;
          }
          break;
      }
      ;
      return false;
    },
    isResultDateRequired: function isResultDateRequired() {
      var decisionType = this.getSelectedDecisionType(),
        decisionTypeDescription = decisionType ? decisionType.description : null;
      if (decisionTypeDescription == 'Approved') {
        return true;
      } else {
        return false;
      }
    },
    isExpirationDateRequired: function isExpirationDateRequired() {
      return this.shouldUseExpirationDate() && this.isResultDateRequired();
    },
    selectedDecisionTypeDidChange: function selectedDecisionTypeDidChange(controller, decisionType) {
      var view = this.getView();
      view.setResultDateRequired(this.isResultDateRequired());
      view.setExpirationDateRequired(this.isExpirationDateRequired());
      this.refreshCategoryQuery(decisionType);
    },
    refreshCategoryQuery: function refreshCategoryQuery(decisionType) {
      var decisionTypeDescription = decisionType ? decisionType.description : null,
        reviewType = this.getReviewType();
      if (decisionTypeDescription == 'Exempt') {
        this.setCategoryQuery(decisionTypeDescription);
      } else {
        this.setCategoryQuery(reviewType);
      }
    },
    refreshAvailableCategories: function refreshAvailableCategories() {
      var decisionId = this.getDecision().getId();
      return DecisionCategory.requestCategories(decisionId, this.getCategoryQuery()).bind(this).tap(this.setAvailableCategories).lastly(this.showLoading());
    },
    setupCategories: function setupCategories() {
      var decision = this.getDecision(),
        selected = decision.getCategories(),
        available = this.getAvailableCategories(),
        categories = [];
      categories = _.map(available, function (m) {
        return {
          id: m.id,
          label: m.label,
          description: m.description,
          _selected: !!_.findWhere(selected, {
            id: m.id
          })
        };
      });
      if (!this.getEditMode()) {
        categories = _.filter(categories, function (f) {
          return f._selected;
        });
      }
      return categories;
    },
    getTemplateProperties: function getTemplateProperties() {
      var decision = this.getDecision(),
        reviewType = decision.getType(),
        availableCats = this.setupCategories(),
        usesCats = availableCats ? availableCats.length : 0,
        types = null;
      var usesVotes = reviewType == "EXPEDITED" || reviewType == "EXEMPT" ? false : true;
      return {
        usesVotes: usesVotes,
        usesRecused: usesVotes,
        usesCategories: usesCats,
        categories: availableCats,
        editable: this.getEditable(),
        edit: this.getEditMode(),
        decision: decision,
        decisionTypes: this.getDecisionTypes(),
        letters: this.getLetters(),
        meetingDocument: this.getMeetingDocument(),
        fromMeetingView: this.getMeetingId() != null,
        shouldUseExpirationDate: this.shouldUseExpirationDate(decision)
      };
    },
    requestEdit: function requestEdit() {
      this.setEditMode(true);
    },
    editModeDidChange: function editModeDidChange() {
      var view = this.getView();
      if (this.getEditMode()) {} else {
        this.setChangeOccured(false);
      }
    },
    refreshEditModePropertyOnView: function refreshEditModePropertyOnView(current, previous) {
      if (previous != null) {
        this.getView().refresh();
      }
    },
    shouldUseExpirationDate: function shouldUseExpirationDate(decision) {
      var viewAvailable = this.getView().isAvailable(),
        decisionType = !viewAvailable && decision ? decision.getDecisionType() : this.getSelectedDecisionType(),
        templateType = this.getDecision().getDocument().getTemplateType(),
        decisionTypeDescription = decisionType ? decisionType.description : null;
      return (decisionTypeDescription == "Approved" || decisionTypeDescription == "Exempt" || decisionTypeDescription == "Rely on NCI-CIRB" || decisionTypeDescription == "Rely on External IRB") && (templateType == "Initial" || templateType == "Renewal");
    },
    requestCancel: function requestCancel() {
      this.setEditMode(false);
    },
    requestPageSave: function requestPageSave() {
      return this.requestSave();
    },
    requestSave: function requestSave() {
      var that = this,
        data = null,
        view = this.getView(),
        validators = this.validation || [];
      if (this.validate(validators)) {
        data = this.getDataByFields(validators);
        this.setEditMode(false);
        Promise.resolve(this.saveData(data)).bind(this).then(function () {
          this.getView().refresh();
        }).lastly(this.showLoading());
      }
    },
    saveData: function saveData(data) {
      var decision = this.getDecision();
      decision.setDecisionType(this.getSelectedDecisionType());
      decision.applyProperties(data);
      return decision.requestUpdate();
    },
    getDataByFields: function getDataByFields(fields) {
      var len = fields ? fields.length : 0,
        data = {},
        view = this.getView(),
        field = null,
        fn = null,
        getter = null,
        i = 0;
      for (i = 0; i < len; ++i) {
        field = fields[i];
        fn = 'get' + helper.camelCase(field);
        getter = view[fn];
        if (getter) {
          data[field] = getter.call(view);
        }
      }
      return data;
    },
    requestPreviousNavigation: function requestPreviousNavigation() {
      var doc = this.getDecision().document,
        meetingId = this.getMeetingId();
      if (meetingId != null) {
        this.getAppController().navigateMeeting({
          id: meetingId
        }, {
          trigger: true
        });
      } else {
        this.getAppController().navigateStudy({
          id: doc.studyId,
          documentId: doc.id
        }, {
          trigger: true
        });
      }
    },
    hasVolatileData: function hasVolatileData() {
      return this.getEditMode() && this.getChangeOccured();
    },
    validateExpirationDate: function validateExpirationDate(expDate) {
      var resultDate = this.getView().getResultDate(),
        validateDate = validation.date('An expiration date is required.', true);
      if (resultDate) {
        if (expDate && expDate.getTime() < resultDate.getTime()) {
          return 'Must exceed the result date.';
        }
      }
      if (this.isExpirationDateRequired()) {
        return validateDate(expDate);
      }
      return true;
    },
    validateResultDate: function validateResultDate(value) {
      var validateDate = validation.date('A result date is required.', true);
      if (this.isResultDateRequired()) {
        return validateDate(value);
      }
      return true;
    },
    validateCategories: function validateCategories(value) {
      if (this.isCategoryRequired() && _.isEmpty(this.getDecision().getCategories())) {
        return 'At least one category is required.';
      }
      return true;
    }
  });
  return DocumentDecisionController;
});

